import React from "react";
import { actions } from "./../store/Insurance";
import { ApplicationState } from "./../store";
import { connect } from "react-redux";

import { RadioButtonGroupBase } from "./RadioButtonGroupBase";
import { useLocalValidation } from "../hooks/useLocalValidation";
import { FormHelperText, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  errorMessage: {
    color: theme.palette.error.main,
  },
}));

const SelfRiskSelector: React.FC<InsuranceCoverageProps> = (props: InsuranceCoverageProps) => {
  const currentCoverage = props.insurance?.coverage?.Coverages?.find(elem => elem.InternalCode === props.insurance?.coverage?.selectedCode);
  const preSelectedDeductible =
    props.insurance?.coverage?.SelectedDeductible ?? currentCoverage?.Deductibles?.find((i: any) => i.IsSelected === true)?.Code;

  const classes = useStyles();

  useLocalValidation({
    fieldName: "selfRisk",
    state: props.insurance?.coverage?.showDeductibleError ? 1 : 0,
    value: "",
    errorMessage: props.insurance?.coverage?.showDeductibleError ? "error" : "",
  });

  return (
    <div>
      <RadioButtonGroupBase
        label={{ title: props.insurance?.coverage?.ui?.deductible?.label }}
        help={{
          title: props.insurance?.coverage?.ui?.deductible?.helpHeader,
          description: props.insurance?.coverage?.ui?.deductible?.helpText,
        }}
        selected={props.inputs.webshopMode === 2 ? undefined : preSelectedDeductible}
        id='selfRisk'
        onChange={props.insuranceSeflRiskChanged}
        values={currentCoverage?.Deductibles?.map(i => ({
          value: i.Code,
          title: i.Name,
        }))}
      />
      {props.insurance?.coverage?.showDeductibleError && (
        <FormHelperText className={classes.errorMessage}>
          {props.insurance.coverage.deductibleErrorMessage ?? "Vi behöver veta vilken självrisk du väljer"}
        </FormHelperText>
      )}
    </div>
  );
};

const connector = connect((state: ApplicationState) => state, {
  insuranceSeflRiskChanged: actions.insuranceSeflRiskChanged,
});

type InsuranceCoverageProps = ApplicationState & { insuranceSeflRiskChanged: Function };

export default connector(SelfRiskSelector);
